module.exports = __webpack_public_path__ + "img/pc_careers.84e8d33.webp";